export enum ProviderPermissions {
  ALL = "Travel:Providers:*",
  READ = "Travel:Providers:Read",
  WRITE = "Travel:Providers:Write",
}

export function hasProviderAccess(userPermissions: string[]): boolean {
  const permissions = [
    ProviderPermissions.READ.toString(),
    ProviderPermissions.WRITE.toString(),
    ProviderPermissions.ALL.toString(),
    "*",
  ];
  return userPermissions.some((permission) => permissions.includes(permission));
}
